<template>
  <div class="wrapper">
    <el-card class="box-card" v-for="(card,index) in update.col.data">
      <div slot="header" class="clearfix">
        <div style="float: right">
          <el-button type="text" @click="addReward()">{{$t('txmis.bt.add')}}</el-button>
          <el-button v-if="update.col.data.length > 1" type="text" @click="delReward(index)">{{$t('txmis.bt.delete')}}</el-button>
        </div>
      </div>
      <div class="text item">
        <el-form-item :label="$t('txmis.accountReward.hierarchy')+(index+1)" :required="true">
          <el-input style="width: 20%" v-model="card.min"></el-input> {{$t('txmis.accountReward.to')}}
          <el-input style="width: 20%" v-model="card.max"></el-input> {{$t('txmis.accountReward.Reward')}}
          <el-input style="width: 20%" v-model="card.amount"></el-input> {{$t('txmis.accountReward.time')}}
        </el-form-item>
      </div>
    </el-card>
  </div>
</template>

<script>
    export default {
        name: 'hierarchy',
        props:["update"],
        methods: {
            addReward(){
                this.update.col.data.push({});
            },
            delReward(index){
                this.update.col.data.splice(index, 1);
            }
        },
        data () {
            return {
            }
        }
    }
</script>
<style scoped>
  /deep/.el-card__header{padding: 0}
  /deep/.el-card__body{padding: 0}
</style>
